import Relay from 'react-relay';

export default class EditHashTagMutation extends Relay.Mutation {
  getMutation() {
    return Relay.QL`mutation{editHashTag}`;
  }

  getVariables() {
    return {
      pid: this.props.pid,
      tag: this.props.tag,
      message: this.props.message,
      agentId: this.props.agentId
    };
  }

  getFatQuery() {
    return Relay.QL`
      fragment on DeleteHashTagPayload {
        agent {
          hashTags
        }
      }
    `;
  }

  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        agent: this.props.agentRelayId
      }
    }];
  }
}



/** WEBPACK FOOTER **
 ** ./src/mutations/EditHashTagMutation.js
 **/